import { cronosClient } from "@/config/client"

interface Response {
  description: {
    startDate: string
    endDate: string
  }
}

export function getUserDates() {
  return cronosClient.get<Response>("/v1/courses/user-dates")
}
